<template>
  <GlobalWindow
      size="600px"
      :title="title"
      :visible.sync="visible"
      :with-footer="false"
  >
    <pre>{{this.AiAnswer}}</pre>
  </GlobalWindow>
</template>

<script>
import GlobalWindow from '@/components/common/GlobalWindow'
import BaseOpera from '../base/BaseOpera'
export default {
  name: 'AiAnswerDrawer',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      AiAnswer: ''
    }
  },
  methods: {
    open (title, row) {
      this.visible = true
      this.title = title
      if (row.status === 'SUCCESS') {
        this.AiAnswer = JSON.stringify(JSON.parse(row.response), null, 4)
      } else {
        this.AiAnswer = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
  pre {
    margin: 0!important;
    white-space: pre-wrap;
    font-size: 14px;
    word-wrap: break-word;
    line-height: 20px;
  }
</style>
